import React from "react";
import { Container, Button } from "./styles";
import { FiUpload } from "react-icons/fi";
import { producaov2 } from "../../../../../services/apis";

export const UpdateLogo = ({
  logoUrl,
  setLogoUrl,
  name,
  error,
  cleanError,
  isLogin = false,
}) => {
  const [loading, setLoading] = React.useState(false);
  const inputRef = React.useRef(null);

  const uploadFile = async (e) => {
    const [image] = e.target.files;

    if (!image) {
      return;
    }

    cleanError();
    setLoading(true);

    const data = new FormData();

    const logoName = name
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .replace(/[^\w\s]/gi, "")
      .trim()
      .replace(/\s+/g, "-");

    data.append("file", image);
    data.append("nome", logoName);
    data.append("path", "incompany/logo");

    await producaov2
      .post("/upload", data)
      .then((res) => setLogoUrl(res.data.url))
      .catch((err) => console.error(err))
      .finally(() => setLoading(false));
  };

  return (
    <Container>
      <div>
        <label>{isLogin ? "Imagem do login" : "Logo da Empresa"}</label>
        <Button
          active={!!name}
          onClick={() => !!name && inputRef.current.click()}
          title={
            !name
              ? "Preencha o nome da empresa para poder fazer o upload da logo"
              : ""
          }
        >
          {loading ? (
            <div className="load" />
          ) : (
            <>
              <FiUpload size={20} />
              {logoUrl ? (isLogin ? "Alterar Imagem do login" : "Alterar Logo") : (isLogin ? "Upload Imagem do login" : "Upload Logo da empresa")}
            </>
          )}

          <input
            type="file"
            ref={inputRef}
            onChange={uploadFile}
            accept="image/*"
          />
        </Button>

        {error && <p>{error}</p>}
      </div>

      {logoUrl && (
        <div className="logo_container">
          <img src={logoUrl} alt="logo" />
        </div>
      )}
    </Container>
  );
};
